import { RFXRevisionedId } from 'interfaces/RFXBackendModel';
import { RFXQuestion } from 'interfaces/RFXQuestionModel';

import { UIInput } from '../../types/uiTypes';
import { putRFXQuestionMutation } from '../mutations/putRFXQuestionMutation';

export interface PutRFXQuestionInput extends UIInput {
  rfxQuestion: RFXQuestion;
}

export interface PutRFXQuestionOutput {
  rfxQuestionId: RFXRevisionedId;
  rfxQuestionVersion: number;
}

export async function putRFXQuestion({
  apolloClient,
  rfxQuestion
}: PutRFXQuestionInput): Promise<PutRFXQuestionOutput> {
  const response = await apolloClient.mutate({
    mutation: putRFXQuestionMutation,
    variables: { rfxQuestion }
  });

  return response.data.putRFXQuestion as PutRFXQuestionOutput;
}
